'use client';

import React from 'react';
import { Box, List, ListItem } from '@mui/material';
import Link from 'next/link';

import DynamicDrawer from '@components/DynamicDrawer';
import DynamicButton from '@components/DynamicButton';
import { MailIcon } from '@components/SVGIcon/Icons';
import DynamicLogo from '@components/DynamicLogo';
import cn from './style.module.scss';

type NavItem = {
  id: number;
  label: string;
  url: string;
  isButton?: boolean;
};

type WharfMobileProps = {
  navData?: {
    item?: NavItem[];
    logo?: {
      src: string;
      alt: string;
      url: string;
    };
  };
};

export default function WharfMobile({ navData }: WharfMobileProps) {
  const { item = [], logo } = navData || {};

  return (
    <Box className={cn.WharfMobileWrapper}>
      <Box className={cn.wharfMobileSHamburger}>
        <DynamicDrawer
          drawerClassName={cn.wharfMobileDrawer}
          drawerBodyClassName={cn.wharfMobileBody}
          drawerContentClassName={cn.wharfMobileContent}
          buttonClassName={cn.wharfMobileButton}
        >
          <Box className={cn.wharfMobileSideMenu}>
            <List className={cn.wharfMobileNavigation}>
              {item.map((navItem) => (
                <ListItem key={navItem.id}>
                  <Link className={cn.wharfNavigationLink} href={navItem.url}>
                    {navItem.label}
                  </Link>
                </ListItem>
              ))}
            </List>
          </Box>
        </DynamicDrawer>
      </Box>
      <Box className={cn.mobileLogoBlock}>
        <Box className={cn.wharfMobileLogo}>
          <DynamicLogo logoImage={logo?.src} alt={logo?.alt || 'Logo'} />
        </Box>
      </Box>
      <Box className={cn.wharfMobileEnquiry}>
        <DynamicButton
          className={cn.wharfMobileButton}
          children={<MailIcon />}
          scrollToId="wharfRegistrationID"
        />
      </Box>
    </Box>
  );
}
